import React from 'react';
import { useNavigate } from 'react-router-dom';
import Container from '../components/ui/Container/Container';
import PageHeading from '../components/ui/PageHeading/PageHeading';
import InfoWidgetsList from '../components/Admin/InfoWidgets/InfoWidgetsList';
import { Route } from '../routes';

const InfoWidgetsPage: React.FC = () => {
  const navigate = useNavigate();

  const addHandler = () => {
    navigate(Route.infoWidget("add"));
  };

  return (
    <>
      <PageHeading onAdd={addHandler} backTo={Route.settings}>Widget Settings</PageHeading>
      <Container>
        <InfoWidgetsList />
      </Container>
    </>
  );
};

export default InfoWidgetsPage;
